import * as linesOfBusiness from "../utils/constants/linesOfBusiness";

const currencyFormat = (promotionEarnings) => {
  return (
    "$" + promotionEarnings.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
  );
};

const getLOBLine = (lob) => {
  switch (lob.toUpperCase()) {
    case linesOfBusiness.PersonalAuto:
      return "Personal Auto";
    case linesOfBusiness.CommercialAuto:
      return "Commercial Auto";
    case linesOfBusiness.CommercialTrucking:
      return "Commercial Trucking";
    case linesOfBusiness.RecreationalVehicle:
      return "Recreational Lines";
    default:
      return "Other";
  }
}

const getDaysRemaining = (countdownDate) => {
  if (countdownDate === null) {
    return null;
  }
  const currentDate = new Date();
  const endDate = new Date(countdownDate);
  const timeDifference = endDate.getTime() - currentDate.getTime();
  const daysRemaining = Math.ceil(timeDifference / (1000 * 3600 * 24));
  return daysRemaining;
}

const convertDate = (date) => {
  const convert = date.split("T");
  const day = convert[0].split('-');
  return day[1] + "/" + day[2] + "/" + day[0];
}

const toPascalCase = (str) => {
  if (!str || typeof str !== 'string') {
    return '';
  }

  const matches = str.match(/[A-Z]{2,}|[A-Z]?[a-z]+|\d+/g);
  if (!matches) {
    return '';
  }
  
  return matches
    .map((x) => x.slice(0, 1).toUpperCase() + x.slice(1).toLowerCase())
    .join("");
};

const getIcons = (data) => {
  const lob = data.lineOfBusiness;
  if (!lob) {
    return <span className="geico-icon icon--primary-blue icon-vehicle promotion-lob-icon" />;
  }
  const lobUpper = lob.toUpperCase();

  function checkRecreational(lineOfBusinessProduct) {
    return lineOfBusinessProduct.lineOfBusiness.toUpperCase() == linesOfBusiness.RecreationalVehicle;
  }
  const recreationalProducts = data.lineOfBusinessProducts?.filter(checkRecreational)[0]?.products ?? [];
  
  switch (lobUpper) {
    case linesOfBusiness.PersonalAuto:
      return <span className="geico-icon icon--primary-blue icon-vehicle promotion-lob-icon" />;
    case linesOfBusiness.CommercialAuto:
      return <span className="geico-icon icon--primary-blue icon-commercial-ins promotion-lob-icon" />;
    case linesOfBusiness.CommercialTrucking:
      return <span className="geico-icon icon--primary-blue icon-commercial-ins promotion-lob-icon" />
    case linesOfBusiness.RecreationalVehicle:
      if (recreationalProducts.includes("GRV") || recreationalProducts.includes("RV")) {
        return <span>
          <span className="geico-icon icon--primary-blue icon-motorcycle promotion-lob-icon" />
          <span className="geico-icon icon--primary-blue icon-rv-ins promotion-lob-icon" />
        </span>
      }
      else {
        return <span className="geico-icon icon--primary-blue icon-motorcycle promotion-lob-icon" />
      }
    default:
      return <span className="geico-icon icon--primary-blue icon-vehicle promotion-lob-icon" />;
  }
};

export { currencyFormat, getDaysRemaining, convertDate, toPascalCase, getLOBLine, getIcons };
